import {
  walletBankDataQa,
  walletDocumentsDataQa,
  walletOverviewDataQa,
  walletPaymentMethodsDataQa,
  walletTransactionDataQa
} from '~/constants/commons/data-qa';

export const useWalletTabs = () => {
  const { $i18n } = useNuxtApp();
  const { t } = $i18n;
  const route = useRoute();

  const tabs = computed(() => [
    {
      label: t('common.overview'),
      value: 'overview',
      dataQa: walletOverviewDataQa?.onglet,
      permission:
        checkPermission('edit') && checkPermission('tdb') && checkPermission('editTabOverView')
    },
    {
      label: t('common.documents'),
      value: 'documents',
      dataQa: walletDocumentsDataQa?.onglet,
      permission: checkPermission('edit') && checkPermission('editTabDocuments')
    },
    {
      label: t('common.transactions'),
      value: 'transactions',
      dataQa: walletTransactionDataQa?.onglet,
      permission:
        checkPermission('edit') &&
        checkPermission('manageOperations') &&
        checkPermission('editTabOperation')
    },
    {
      label: t('common.bankAccounts'),
      value: 'bank-accounts',
      dataQa: walletBankDataQa?.onglet,
      permission:
        checkPermission('edit') &&
        checkPermission('editTabBankingInformation') &&
        checkPermission('editTabBankingInformationListeIban')
    },
    {
      label: t('common.paymentMethods'),
      value: 'payment-methods',
      dataQa: walletPaymentMethodsDataQa?.onglet,
      permission: checkPermission('edit') && checkPermission('editTabBankingInformation')
    },
    {
      label: t('common.walletInformation'),
      value: 'wallet-information',
      permission: checkPermission('edit') && checkPermission('editTabWalletDetail')
    },
    {
      label: t('common.walletStatement'),
      value: 'wallet-statement',
      permission: checkPermission('edit') && checkPermission('walletStatement')
    },
    {
      label: t('common.logs'),
      value: 'logs',
      permission: checkPermission('edit') && checkPermission('editTabControlJournal')
    }
  ]);

  const selectedTab = computed(() =>
    Array.isArray(route.params.tab) ? route.params.tab[0] : route.params.tab
  );

  const activeTab = ref(selectedTab.value);
  const activePMTab = computed(() => route.params?.pmtab);

  const handleActiveTabs = (tab: string) => selectedTab.value === tab;

  const lastSelectedPaymentMethod = ref<string>('1');
  const paymentMethod = ref([lastSelectedPaymentMethod.value]);

  const handleNavbar = () => {
    const subTabs = [
      {
        label: t('wallets.paymentMethods.sddMandates.list.card'),
        value: '1',
        dataQa: walletPaymentMethodsDataQa?.sddMandatesOnglet,
        permission: checkPermission('editTabBankingInformationMandatSDD')
      },
      {
        label: t('wallets.paymentMethods.virtualIbans.list.card'),
        value: '2',
        dataQa: walletPaymentMethodsDataQa?.virtualIbansOnglet,
        permission: true
      },
      {
        label: t('wallets.paymentMethods.savedCards.list.card'),
        value: '3',
        dataQa: walletPaymentMethodsDataQa?.savedCardsOnglet,
        permission: checkPermission('editTabBankingInformationRegisteredCards')
      },
      {
        label: t('wallets.paymentMethods.paymentForms.list.card'),
        value: '4',
        dataQa: walletPaymentMethodsDataQa?.paymentFormsOnglet,
        permission: true
      }
    ];
    return subTabs.filter((subTab) => subTab.permission);
  };

  return {
    tabs,
    selectedTab,
    activeTab,
    activePMTab,
    handleActiveTabs,
    lastSelectedPaymentMethod,
    paymentMethod,
    handleNavbar
  };
};
